import store from "../vuex/index";
import conditionHelper from "@/helpers/condition";

const ZONE_TYPE = {
  CANDIDATE: "candidate",
  EMPLOYEE: "employee",
};

export default {
  // Navigation guard for candidate and public zones
  restrictAccesstoUnauthorizedUsers: function(to, from, next) {
    let user = JSON.parse(localStorage.getItem("user"));
    const pk_ix_adv_account_application_status = user && user.applicationStatus;
    if (pk_ix_adv_account_application_status === null) {
      store.dispatch("setRedirectRouter", to);
      next("/");
    } else {
      const requestedMatchedRouteZone = to.matched.find((element) => {
        return element.meta.zone != undefined;
      });

      let isAllowedToAccess = null;

      if (requestedMatchedRouteZone.meta.zone === ZONE_TYPE.CANDIDATE) {
        isAllowedToAccess = pk_ix_adv_account_application_status != 8;
      } else if (requestedMatchedRouteZone.meta.zone === ZONE_TYPE.EMPLOYEE) {
        isAllowedToAccess = pk_ix_adv_account_application_status === 8;
      }

      if (isAllowedToAccess) {
        if (to.params.company != from.params.company) {
          store.commit('auth/STYLES_LOADED', false);
          const newUser = requestedMatchedRouteZone.meta.zone === ZONE_TYPE.EMPLOYEE ? 'employee' : 'candidate'
          var headHTML = document.getElementsByTagName('head')[0].innerHTML;
          headHTML    += '<link type="text/css" rel="stylesheet" href="/src/themes/scss/_vitalliance-' + newUser + '.theme.css">';
          if(document.getElementsByTagName('head') && document.getElementsByTagName('head')[0] &&   document.getElementsByTagName('head')[0].innerHTML)  {
            document.getElementsByTagName('head')[0].innerHTML = headHTML;
          }
          newUser === 'employee' ? import(`../themes/scss/_vitalliance-employee.theme.scss`) : import(`../themes/scss/_vitalliance-candidate.theme.scss`)

          if(to.meta.key) {
            const permission = conditionHelper(to.meta.key);

            if(permission) {
              next();
            } else {
              next("/");
            }
          } else if (to.meta.multiConditions && to.meta.multiConditions.length) {
              const condition = to.meta.multiConditions.find(item => conditionHelper(item));
              if (condition) {
                next();
              } else {
                next("/");
              }
            }
          next()
        } else {
          next();
        }
      } else {
        next("/");
      }
    }
  },

  // Naviguation guard for public zone
  redirectIfAuthenticated: function(to, from, next) {
    // If the user is visiting the public zone it has a token then load the correct theme and allow him to navigate it
    const isAuthenticated = Boolean(localStorage.getItem("isAuthenticated"));

    // If the user is authenticated
    if (isAuthenticated) {
      if (to.name === "email-confirmation" || to.name === "impersonate") {
        import(`../themes/scss/vitalliance.theme.scss`).then((vars) => {
          next();
        });
      } else {
        store.dispatch("auth/REDIRECT_AFTER_LOGIN", true);
      }
    } else {
      localStorage.clear();
      import(`../themes/scss/vitalliance.theme.scss`).then((vars) => {
        next();
      });
    }
  },

  restrictForUnconfirmedEmails: function(to, from, next) {
    let user = JSON.parse(localStorage.getItem("user"));
    const accountCreationStatus = user.accountCreationStatus;

    if (accountCreationStatus === 5) {
      next();
    } else {
      next("/");
    }
  },

  restrictMandataire: function (to, from, next) {
    let user = JSON.parse(localStorage.getItem('user'));
    user.isMandataire && !user.isPrestataire ? next('/') : next();
  },

  /* Note: for account 13 {
    name: "candidate-telemanagement",
    path: "telegestion",
    component: load("Telemanagement"),
    beforeEnter: guards.restrictForExADVAccount,
  },*/
  restrictForExADVAccount: function (to, from, next) {
    let user = JSON.parse(localStorage.getItem("user"));
    const applicationStatus = user.applicationStatus;
    const isEmployee = user.isEmployee;

    if (applicationStatus === 13 && isEmployee) {
      next();
    } else {
      next("");
    }
  }
};
